<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25.664" height="18.8" viewBox="0 0 25.664 18.8">
    <g transform="translate(0.4 0.4)">
      <path :style="{stroke:color}" class="a" d="M210.266,54.1h6a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h-6a1,1,0,0,1-1-1h0A1,1,0,0,1,210.266,54.1Z" transform="translate(-205.266 -50.1)" />
      <path :style="{stroke:color}" class="a" d="M210.266,58.1h6a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h-6a1,1,0,0,1-1-1h0A1,1,0,0,1,210.266,58.1Z" transform="translate(-205.266 -50.1)" />
      <path :style="{stroke:color}" class="a" d="M210.266,62.1h6a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h-6a1,1,0,0,1-1-1h0A1,1,0,0,1,210.266,62.1Z" transform="translate(-205.266 -50.1)" />
      <path :style="{stroke:color}" class="b" d="M218.266,52.1h-10a1,1,0,0,0-1,1v12a1,1,0,0,0,1,1h10a1,1,0,0,0,1-1v-12A1,1,0,0,0,218.266,52.1Zm-10-2a3,3,0,0,0-3,3v12a3,3,0,0,0,3,3h10a3,3,0,0,0,3-3v-12a3,3,0,0,0-3-3Z" transform="translate(-205.266 -50.1)" />
      <g transform="translate(15.177 4.716)">
        <path class="c" d="M225.646,63.384,229.93,59.1l-4.284-4.284" transform="translate(-220.443 -54.816)" />
        <line class="c" x1="9.488" transform="translate(0 4.284)" />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: "AssignmentIcon",
  props: {
    color: String
  }
}

</script>
<style scoped>
.a,
.b {
  fill: #fff;
  stroke: #57b98f;
  stroke-width: 0.8px;
}

.b {
  fill-rule: evenodd;
}

.c {
  fill: none;
  stroke: #fff;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.2px;
}

</style>
